<template>
    <div class="adjust-item-task-add">
        <el-dialog
            id="adjust-item-task-add-dialog-id"
            :close-on-click-modal="false"
            :modal="false"
            :modal-append-to-body="false"
            :visible.sync="isVisible"
            class="frame-dialog"
            title="添加"
            top="5vh"
            width="70%"
            @close="handleClose"
        >
            <div>
                <!-- 弹框内容 -->
                <sieve-single-center ref="sieveSingleCenter"/>
                <div class="page-module-btn">
                    <el-button type="primary" @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="handleOk">添 加</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { PromiseUtils } from '../../utils/promise';
import SieveSingleCenter from './sieveSingleCenter';

export default {
    name: 'train-adjust-task-add',
    components: { SieveSingleCenter },
    data() {
        return {
            isVisible: false,
            initSearchInfo: {
                taskStatus: '0' // 默认显示 “待调度”，且不能修改
            }
        };
    },
    created() {
        this._resolve = () => {
        };
        this._reject = () => {
        };
        this.messenger = PromiseUtils.buildErrorMessenger(this.$message);
    },
    methods: {
        async open({ keepData, trainTaskNoSet }) {
            this.isVisible = true;
            if (!keepData && this.$refs.sieveSingleCenter) {
                this.$refs.sieveSingleCenter.tlSetTargetTaskNoSet(trainTaskNoSet);
            }
            return new Promise((resolve, reject) => {
                this._resolve = (v) => {
                    resolve(v);
                };
                this._reject = (v) => {
                    reject(v);
                    this.isVisible = false;
                };
            });
        },
        close() {
            this.isVisible = false;
        },
        handleClose() {
            // this.$emit('on-close');
            this._reject();
        },
        handleOk() {
            // this.$emit('on-add')
            this._resolve({
                tasksToAdd: this.$refs.sieveSingleCenter.tlGetSelectedRows(),
                tasksMayToAdd: this.$refs.sieveSingleCenter.tlGetAllRows()
            });
        }
    }
};
</script>

<style lang="less" scoped>
.adjust-item-task-add {
    .page-module-btn {
        display: flex;
        justify-content: end;
        margin: 12px 10px 0 0;
    }
}
</style>
<style lang="less">
.adjust-item-task-add {
    .mPane3-back-up {
        .el-table {
            min-height: calc(~ '100vh - 366px') !important;
            max-height: calc(~ '100vh - 366px') !important;
        }
    }

    .frame-dialog {
        .el-dialog {
            min-width: 1200px;
        }
    }
}
</style>
